import React from 'react';
import { IIconProps } from '../../interfaces';
const YouTubeIcon = (props: IIconProps) => {
  /*w13 h16*/
  return (
      <svg width={props.width} height={props.height} viewBox="0 0 37 26"  fill="none" >
          <title>{props.title}</title>

          <path fillRule="evenodd" clipRule="evenodd" d="M32.2657 0.771801C33.8148 1.19753 35.0343 2.44999 35.4476 4.04028C35.6468 4.80385 35.7937 5.78851 35.9008 6.82261C35.9681 7.46395 36.0203 8.12314 36.0601 8.76173C36.2002 10.9796 36.2002 12.938 36.2002 12.938C36.2002 12.938 36.2002 18.9517 35.4476 21.8343C35.0343 23.4246 33.8148 24.677 32.2657 25.1028C29.4586 25.8746 18.2002 25.8746 18.2002 25.8746C18.2002 25.8746 6.94178 25.8746 4.13473 25.1028C2.58564 24.677 1.36614 23.4246 0.951397 21.8343C0.200195 18.9517 0.200195 12.938 0.200195 12.938C0.200195 12.938 0.200195 6.92287 0.951397 4.04028C1.36614 2.44999 2.58564 1.19753 4.13473 0.771801C6.94178 0 18.2002 0 18.2002 0C18.2002 0 29.4586 0 32.2657 0.771801ZM23.8253 13.4997L14.8246 7.87457V19.1247L23.8253 13.4997Z" fill="black"/>
     </svg>
  )
};

export default YouTubeIcon;